export default "__VITE_ASSET__C_j$EoZ3__"